enum DownloadFromStadiumEnum {
  CURRENT,
  PREVIOUS,
  ANY_PREVIOUS,
}

export default DownloadFromStadiumEnum;
